import React from 'react';

interface NoAssetsFoundProps {
  className?: string;
}

export const NoAssetsFound: React.FC<NoAssetsFoundProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 -23.5 139 139"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M115.833 80.5C122.204 80.5 127.359 75.325 127.359 69L127.417 11.5C127.417 5.175 122.204 0 115.833 0H23.1667C16.7958 0 11.5833 5.175 11.5833 11.5V69C11.5833 75.325 16.7958 80.5 23.1667 80.5H0V92H139V80.5H115.833ZM23.1667 11.5H115.833V69H23.1667V11.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
